export const convertOptionsToString = (options) =>
    Object.keys(options)
        .map((key) => `variant[${key}]=${options[key]}`)
        .join('&')

export const convertOptionsToStringWithVerticalLine = (options) =>
    Object.keys(options)
        .map((key) => `${key}:${options[key]}`)
        .join(`|`)
